class PriceModel {
  name = null;
  value = 0;
  gym_id = null;
  constructor(priceData) {
    if (priceData !== undefined) {
      let { name, value, gym_id } = priceData;
      Object.assign(this, {
        name,
        value: Number(value),
        gym_id: Number(gym_id)
      });
    }
  }
}

export default PriceModel;
